import React, { useMemo } from 'react';

export function ProcessContentImage({ content, baseUrl = ''}) {
   const processedHtml = useMemo(() => {
    if (!content) return '';
    if (!baseUrl) return content;

    // Reemplaza src="/ruta" o src='/ruta' por src="baseUrl/ruta"
    return content.replace(
      /src=(["'])\/([^"']+)\1/g,
      (match, quote, path) => `src=${quote}${baseUrl}/${path}${quote}`
    );
  }, [content, baseUrl]);

  return (
    <div
     
      dangerouslySetInnerHTML={{ __html: processedHtml }}
    />
  );
}